import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BilledProduct, KeyValueSet, LocalService, Status, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-product-validation',
  templateUrl: './product-validation.component.html',
  styleUrls: ['./product-validation.component.scss']
})
export class ProductValidationComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["billing"]; maxBodyHeight = 0;
  status: Status; invalidProducts: KeyValueSet[]; products: BilledProduct[];
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private activeModal: NgbActiveModal, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    this.products = this.products.filter(product => this.invalidProducts.some(invalidProduct => invalidProduct.key == product.productId && product.details.v15 == (invalidProduct.s_value ?? '')));
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }
}
